export default "https://assets.egbcdn.net/assets/packs/_/images/crypto-logotypes/litecoin-ltc-logo-379d21aff99601d5d005577bae00081d.png";